import { MinzeElement } from 'minze'

export interface LvcClockIcon {}

export class LvcClockIcon extends MinzeElement {
  html = () => `
    <svg part="icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M18.0603 6.0139C16.6914 4.43265 14.4851 3.33594 12.0672 3.33594C7.23132 3.33594 3 6.91535 3 12.0001C3 16.4666 6.27715 20.6643 11.3619 20.6643C16.4467 20.6643 21 16.836 21 12.2155C21 9.85974 20.0446 7.30342 18.5892 5.67511M11.3619 6.85449C11.2947 8.10274 11.0259 10.8212 10.9129 12.1081C10.8495 12.8296 11.4516 13.425 12.1753 13.3972C12.8832 13.37 13.6314 13.3527 14.029 13.3576C14.7263 13.3662 15.2114 13.3325 15.8319 13.3576" stroke="#1E007D" stroke-width="1.5" stroke-linecap="round"/>
    </svg>
  `

  css = () => `
  `
}
